module.exports = __webpack_public_path__ + "static/img/dot.211ec1a5.png";